import React, { createContext, useContext, useEffect, useState } from 'react';
import { Client, Dashboard, NavigationMenuGroup, NavigationMenuItem } from '../../core/DashboardApi/api';
import { REACT_APP_APPLICATION_ID, REACT_APP_PORTAL_API_URL } from '../../KeyVariables';
import { useNavigate } from 'react-router-dom';

interface DashboardContextType {
  dashboards: Dashboard[];
  defaultDashboard: Dashboard | null;
  currentDashboard: Dashboard | null;
  changeDashboard: (dashboard: Dashboard) => void;

}

const DashboardContext = createContext<DashboardContextType>({
  dashboards: [],
  defaultDashboard: null,
  currentDashboard: null,
  changeDashboard: () => { },

});

export const DashboardProvider = ({ children }) => {
  const [dashboards, setDashboards] = useState<Dashboard[]>([]);
  const [defaultDashboard, setDefaultDashboard] = useState<Dashboard | null>(null);
  const [currentDashboard, setCurrentDashboard] = useState<Dashboard | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const apiUrl = REACT_APP_PORTAL_API_URL;
    const appId = REACT_APP_APPLICATION_ID;
    const client = new Client(apiUrl);
    client.getdashboards(appId).then(dash => {
      setDashboards(dash.dashboards!);
      setDefaultDashboard(dash.defaultDashboard!)
      if(localStorage.getItem("currentDashboardTag") != null && 
        dash.dashboards?.find(x => x.tag == localStorage.getItem("currentDashboardTag"))) {
        setCurrentDashboard(dash.dashboards.filter(x=>x.tag == localStorage.getItem("currentDashboardTag"))[0])
      } else {
        setCurrentDashboard(dash.defaultDashboard!)
        localStorage.setItem("currentDashboardTag",dash.defaultDashboard?.tag!);
      }
    })
  }, [])

  const changeDashboard = (dashboard: Dashboard) => {
    setCurrentDashboard(dashboard);
    localStorage.setItem("currentDashboardTag", dashboard.tag!)
    navigate(dashboard.tag!);
  };

  return (
    <DashboardContext.Provider value={{ dashboards, defaultDashboard, currentDashboard, changeDashboard }}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboards = () => useContext(DashboardContext);
